<template>
    <div :class="init_table_class">
        <slot name="total_string">
            <div class="ml-2 number-text" v-if="!ignore_total_string">{{ showing }}</div>
        </slot>
        <div :class="[ 'position-relative', init_list_class == null ? 'thumb-list cat' : init_list_class]">
            <slot name="actionBar"></slot>
            <template v-if="with_draggable">
                <div v-if="draggable_holder_class == null">
                    <draggable v-model="listing_data.data"
                               draggable=".draggable-item"
                               @end="reorder"
                               v-if="with_draggable"
                    >
                        <slot name="scopeListing" :listing_data="listing_data" :row_checkbox="row_checkbox" :hasRecords="hasRecords" :clickCheckBox="clickCheckBox" />
                    </draggable>
                    <slot name="addItem"></slot>
                </div>
                <div v-else
                     :class="draggable_holder_class"
                >
                    <draggable v-model="listing_data.data"
                               draggable=".draggable-item"
                               @end="reorder"
                               v-if="with_draggable"
                    >
                        <slot name="scopeListing" :listing_data="listing_data" :row_checkbox="row_checkbox" :hasRecords="hasRecords" :clickCheckBox="clickCheckBox" />
                    </draggable>
                    <slot name="addItem"></slot>
                </div>
            </template>
            <template v-else>
                <slot name="addItem"></slot>
                <slot name="scopeListing" :listing_data="listing_data" :row_checkbox="row_checkbox" :hasRecords="hasRecords" :clickCheckBox="clickCheckBox" />
                <slot name="addItemPrefix"></slot>
            </template>
        </div>
        <div class="table-pagination border-0 bg-transparent" v-if="init_paginate && hasRecords && !$store.state.submitting">
            <div class="navigate">
                <a href="#" class="btn-page" @click.stop.prevent="first" v-if="meta.current_page != 1">
                    <i class="fas fa-step-backward" aria-hidden="true"></i>
                </a>
                <a href="#" class="btn-page disabled" v-else>
                    <i class="fas fa-step-backward" aria-hidden="true"></i>
                </a>
                <a href="#" class="btn-page disabled" v-if="onFirstPage">
                    <i class="fas fa-play fa-flip-horizontal" aria-hidden="true"></i>
                </a>
                <a href="#" class="btn-page" @click="previous" rel="prev" v-else>
                    <i class="fas fa-play fa-flip-horizontal" aria-hidden="true"></i>
                </a>
                {{ trans[locale].page }}
                <div class="dropdown">
                    <button class="btn dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true"
                            aria-expanded="false">{{ meta.current_page }}
                    </button>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" :class="[ i == meta.current_page ? 'active' : '']"
                           v-for="i in meta.last_page" @click="changePage(i)">{{ i }}</a>
                    </div>
                </div>
                <a href="#" class="btn-page" @click.stop.prevent="next" v-if="meta.hasMorePage" rel="next">
                    <i class="fas fa-play" aria-hidden="true"></i>
                </a>
                <a href="#" class="btn-page disabled" v-else rel="next">
                    <i class="fas fa-play" aria-hidden="true"></i>
                </a>
                <a href="#" class="btn-page" v-if="meta.current_page != meta.last_page" @click.stop.prevent="last">
                    <i class="fas fa-step-forward" aria-hidden="true"></i>
                </a>
                <a href="#" class="btn-page disabled" v-else>
                    <i class="fas fa-step-forward" aria-hidden="true"></i>
                </a>

                <div class="no-of-items">
                    {{ trans[locale].display }}
                    <div class="dropdown">
                        <button class="btn dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true"
                                aria-expanded="false">{{ meta.per_page }}
                        </button>
                        <div class="dropdown-menu">
                            <a class="dropdown-item" :class="[ i == meta.per_page ? 'active' : '']"
                               v-for="i in per_page_array" @click="changePerPage(i)">{{ i }}</a>
                        </div>
                    </div>
                    {{ trans[locale].perPage }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import draggable from 'vuedraggable';
    import { helperCommon } from "../../mixins/helper.common";
    import checkBoxInTable from "../../mixins/checkBoxInTable";

    export default {
        mixins: [ helperCommon, checkBoxInTable ],
        data() {
            return {
                listing_data: this.init_data ? JSON.parse(this.init_data) : { data: [] },
                locale: window.locale,
                lang: {
                    en: {
                        display: 'Display',
                        page: 'Page',
                        perPage: 'Items/Page',
                    },
                    'zh-HK': {
                        display: '顯示',
                        page: '頁數',
                        perPage: '項/頁',
                    },
                    dev: {
                        display: 'table.vue.lang.display',
                        page: 'table.vue.lang.page',
                        perPage: 'table.vue.lang.perPage',
                    }
                },
                per_page_array: this.init_per_page,
            }
        },
        components: {
            draggable
        },
        props: {
            with_draggable: {
                required: false,
                type: Boolean,
                default: false
            },
            ordering_url: {
                required: false,
                type: String,
                default: null
            },
            draggable_holder_class: {
                required: false,
                type: String,
                default: null
            },
            element_id: {
                required: false,
                type: String,
                default: null
            },
            ignore_total_string: {
                required: false,
                type: Boolean,
                default: false,
            },
            url: {
                required: true,
                type: String,
            },
            responsive: {
                required:false,
                type: Boolean,
                default: true,
            },
            init_table_class: {
                required:false,
                type: String,
                default: 'table-style1 table-hover table-striped',
            },
            init_list_class: {
                required:false,
                type: String,
                default: null,
            },
            init_data: {
                default: null,
                required: false,
            },
            init_thead_class: {
                required:false,
                default: () => {
                    return [];
                },
            },
            init_tbody_class: {
                required:false,
                default: () => {
                    return [];
                },
            },
            extract_ordering_callback: {
                required: false,
                type: String,
                default: '',
            },
            extract_hook_success_callback: {
                required: false,
                type: Boolean,
                default: false,
            },
            extract_hook_fail_callback: {
                required: false,
                type: Boolean,
                default: false,
            },
            ignore_query_string: {
                required: false,
                type: Boolean,
                default: false,
            },
            init_paginate: {
                required: false,
                type: Boolean,
                default: false
            },
            init_per_page: {
                required: false,
                type: Array,
                default: () => {
                    return [24,48,96];
                }
            }
        },
        beforeDestroy() {
			window.eventHub.$off('extract-listing-data', (element_id) => {
                if (_.isUndefined(element_id) || element_id == this.element_id) {
                    return this.listing_data;
                } else {
                    return '';
                }
            });
			window.eventHub.$off('plain-listing-reload-data', (element_id) => {
                if (_.isUndefined(element_id) || element_id == this.element_id) {
                    if (this.ignore_query_string)
                    {
                        this.fetchData(this.url);
                    } else {
                        if (this.url.includes('?')) {
                            this.fetchData(this.url + _.replace(this.$store.getters.query, '?', '&'));
                        } else {
                            this.fetchData(this.url + this.$store.getters.query);
                        }
                    }
                }
            });

            window.eventHub.$off('set-plain-listing-data', (param) => {
                if (!_.isUndefined(param.element_id) && param.element_id == this.element_id) {
                    this.listing_data[param.element_id].data = param.listing_data;
                }
            });
        },
        beforeMount() {
            this.changePerPage(_.first(this.per_page_array));
        },
        mounted() {
            if (this.url != '') {
                if (this.ignore_query_string)
                {
                    this.fetchData(this.url);
                } else {
                    if (this.url.includes('?')) {
                        this.fetchData(this.url + _.replace(this.$store.getters.query, '?', '&'));
                    } else {
                        this.fetchData(this.url + this.$store.getters.query);
                    }
                }
            }

			window.eventHub.$on('extract-listing-data', (element_id) => {
			    if (_.isUndefined(element_id)) {
                    window.eventHub.$emit('pull-listing-data', this.listing_data);
                } else {
                    if (element_id == this.element_id) {
                        window.eventHub.$emit('pull-listing-data', this.listing_data, element_id);
                    }
                }
            });
			window.eventHub.$on('plain-listing-reload-data', (element_id) => {
                if (_.isUndefined(element_id) || element_id == this.element_id) {
                    if (this.ignore_query_string)
                    {
                        this.fetchData(this.url);
                    } else {
                        if (this.url.includes('?')) {
                            this.fetchData(this.url + _.replace(this.$store.getters.query, '?', '&'));
                        } else {
                            this.fetchData(this.url + this.$store.getters.query);
                        }
                    }
                }
            });

            window.eventHub.$on('set-plain-listing-data', (param) => {
                if (!_.isUndefined(param.element_id) && param.element_id == this.element_id) {
                    this.listing_data = param.listing_data;
                }
            });
        },
        methods: {
            fetchData(url) {
                let self = this;
                self.$store.commit('setSubmitting', true);

                let successCallback = (response) => {
                    self.listing_data = response.data;
                    self.$store.commit('setSubmitting', false);
                    if (self.extract_hook_success_callback) {
                        if (_.isNull(this.element_id)) {
                            window.eventHub.$emit('extract-listing-data');
                        } else {
                            window.eventHub.$emit('extract-listing-data', self.element_id);
                        }
                    }
                };

                let failCallback = (error) => {
                    self.$store.commit('setNotificationType', 'danger');
                    self.$store.commit('setNotification', error.response.data.message);
                    self.$store.commit('setSubmitting', false);
                    if (self.extract_hook_fail_callback) {
                        if (_.isNull(this.element_id)) {
                            window.eventHub.$emit('extract-listing-data');
                        } else {
                            window.eventHub.$emit('extract-listing-data', self.element_id);
                        }
                    }
                }
                if (url.includes('?')) {
                    url += '&_t=' + new Date().getTime();
                } else {
                    url += '?_t=' + new Date().getTime();
                }
                this.$root.ajax_get(url, successCallback, failCallback);
            },
            search(keyword) {
                this.$store.commit('setFilterKeyword', keyword);
            },
            sort(field) {
                this.$store.commit('setFilterSort', field);
                this.$store.commit('toggleFilterOrder')
            },
            changePage(val) {
                this.$store.commit('setFilterPage', val);
            },
            changePerPage(val) {
                this.$store.commit('setFilterPerPage', val);
            },
            first() {
                this.changePage(1);
            },
            last() {
                this.changePage(this.meta.last_page);
            },
            next() {
                this.changePage(this.meta.current_page + 1);
            },
            previous() {
                this.changePage(this.meta.current_page - 1);
            },
            reorder(e) {
                let self = this;
                self.listing_data.data.forEach((item, index) => {
                    self.$set(self.listing_data.data[index], 'ordering', index + 1);
                });
                self.updateOrdering();
                if (self.extract_ordering_callback != '')
                {
                    let param = {
                        selected_media: self.listing_data
                    };
                    window.eventHub.$emit(self.extract_ordering_callback, self._cloneObject(param));
                }
            },
            getOrderingFormData() {
                let formData = { listing_data : [] };
                _.forEach(this.listing_data.data, (record) => {
                    formData.listing_data.push( { code: record.key, ordering: record.ordering } );
                });

                return formData;
            },
            updateOrdering: _.throttle(function(){
                let formData = this.getOrderingFormData();
                let ajaxSuccessCallback = (response) => {
                    this.$nextTick(function () {
                        window.eventHub.$emit('plain-listing-reload-data');
                        this.$store.commit('setNotification', response.data.msg);
                    });
                };
                let ajaxFailCallback = (error) => {
                    if (error.response.status == '422') {
                        this.$store.commit('setValidationError', error.response.data.errors)
                    } else {
                        this.$store.commit('setError', error.response.data.msg)
                    }
                };

                this.$store.commit('clearNotification');
                this.$store.commit('clearValidationError');
                this.$store.commit('clearError');

                if (!_.isNull(this.ordering_url) && this.ordering_url != '' &&
                    _.size(formData.listing_data) > 0)
                {
                    let url = this.ordering_url;
                    if (this.ordering_url.includes('?')) {
                        url = url + _.replace(this.$store.getters.query, '?', '&');
                    } else {
                        url = url + this.$store.getters.query;
                    }

                    this.$root.ajax_patch(url, formData, ajaxSuccessCallback, ajaxFailCallback);
                }
            }, 500),
        },
        watch: {
            filter() {
                if (this.url.includes('?')) {
                    this.fetchData(this.url + _.replace(this.$store.getters.query, '?', '&'));
                } else {
                    this.fetchData(this.url + this.$store.getters.query);
                }
            },
            url() {
                if (this.url != '') {
                    if (this.ignore_query_string)
                    {
                        this.fetchData(this.url);
                    } else {
                        if (this.url.includes('?')) {
                            this.fetchData(this.url + _.replace(this.$store.getters.query, '?', '&') + '&page=' + this.page);
                        } else {
                            this.fetchData(this.url + this.$store.getters.query + '&page=' + this.page);
                        }
                    }
                }
            },
        },
        computed: {
            hasRecords() {
                return this.listing_data.data ? this.listing_data.data.length : false;
            },
            filter() {
                return this.$store.getters.query;
            },
            showing() {
                let str = this.listing_data ? this.listing_data.paginate : '';
                if (this.init_paginate)
                {
                    if (str)
                        return str.replace(':from', this.listing_data.meta.from)
                            .replace(':total', this.listing_data.meta.total)
                            .replace(':to', this.listing_data.meta.to)
                            .replace(new RegExp('null', 'g'), 0);
                } else {
                    if (str)
                        return str.replace(':total', _.isUndefined(this.listing_data.data) ? 0 : _.size(this.listing_data.data));
                }
            },
            hasPage() {
                if (!this.listing_data.hasOwnProperty('meta')) return false;
                return this.listing_data.meta.total > 0;
            },
            onFirstPage() {
                if (!this.listing_data.hasOwnProperty('meta')) return false;
                return this.listing_data.meta.current_page == 1;
            },
            hasMorePage() {
                if (!this.listing_data.hasOwnProperty('meta')) return false;
                return this.listing_data.meta.current_page < this.listing_data.meta.last_page;
            },
            meta() {
                if (!this.listing_data.hasOwnProperty('meta')) return {};
                return {
                    showing: this.showing,
                    hasMorePage: this.hasMorePage,
                    hasPage: this.hasPage,
                    onFirstPage: this.onFirstPage,
                    current_page: this.listing_data.meta.current_page,
                    per_page: this.listing_data.meta.per_page,
                    last_page: this.listing_data.meta.last_page,
                    first_item: this.listing_data.meta.from,
                }
            },
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Table/ThumbList.vue